/**
 * useSourceTracking — Fase 0
 *
 * Runs once at app mount. Resolves the access source (pwa/email/browser/native)
 * from URL params + display-mode, persists it for the tab, and emits `app_opened`
 * exactly once per tab session.
 *
 * Safe-by-design: never throws, never blocks render.
 */

import { useEffect } from "react";
import { resolveSource, trackAppOpenedOnce } from "@/lib/access-telemetry";

export function useSourceTracking() {
  useEffect(() => {
    // Resolve & cache source synchronously so any downstream event in this tab
    // inherits the same attribution.
    resolveSource();
    trackAppOpenedOnce();
  }, []);
}
